<div class="form-container">
  <hau-form [formGroup]="form">
    <hau-form-field label="Zusätzliche Feldgruppen erlauben" [validation]="form.validation.addAdditionalCollections">
      <nb-toggle formControlName="addAdditionalCollections">
        Benutzer kann beim Erstellen zusätzliche Feldgruppen hinzufügen
      </nb-toggle>
    </hau-form-field>
  </hau-form>

</div>
